export const ControlProgram = {
    path: '/control_programs',
    name: 'control_programs',
    component: () => import('@/views/Notification/ControlProgram/ControlProgramPage.vue'),
    children: [
        // Parent
        {
            path: '/control_programs/parent/module/:module/add',
            name: 'control_programs.parent.add',
            component: () => import('@/views/Notification/ControlProgram/Form/ParentControlProgramForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/control_programs/parent/module/:module/edit/:id',
            name: 'control_programs.parent.edit',
            component: () => import('@/views/Notification/ControlProgram/Form/ParentControlProgramForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/control_programs/parent/module/:module/delete/:id',
            name: 'control_programs.parent.delete',
            component: () => import('@/views/Notification/ControlProgram/Form/ParentControlProgramForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/control_programs/parent/module/:module/view/:id',
            name: 'control_programs.parent.view',
            component: () => import('@/views/Notification/ControlProgram/Form/ParentControlProgramForm.vue'),
            props: {viewAction: true}
        },
        // Child
        {
            path: '/control_programs/child/module/:module/add',
            name: 'control_programs.child.add',
            component: () => import('@/views/Notification/ControlProgram/Form/ChildControlProgramForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/control_programs/child/module/:module/edit/:id',
            name: 'control_programs.child.edit',
            component: () => import('@/views/Notification/ControlProgram/Form/ChildControlProgramForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/control_programs/child/module/:module/delete/:id',
            name: 'control_programs.child.delete',
            component: () => import('@/views/Notification/ControlProgram/Form/ChildControlProgramForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/control_programs/child/module/:module/view/:id',
            name: 'control_programs.child.view',
            component: () => import('@/views/Notification/ControlProgram/Form/ChildControlProgramForm.vue'),
            props: {viewAction: true}
        },
    ],
}